"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _useGlobalStyles = require("../../styles/global/useGlobalStyles");

var _table = require("./table.style");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var TableGrid = function TableGrid(props) {
  (0, _useGlobalStyles.useGlobalStyles)();
  var classes = (0, _table.useStyles)(props);
  var itemRef = (0, _react.useRef)();
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(classes.col4, " ").concat(classes.grid, " ").concat(props.item["default"] ? classes.gridSelected : null),
    ref: itemRef
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(classes.card)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(classes.cardHeader)
  }, /*#__PURE__*/_react["default"].createElement("div", null, props.item.addressName), /*#__PURE__*/_react["default"].createElement("div", null, props.item.actions.checkbox)), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
    onClick: function onClick() {
      var parent = itemRef.current.parentNode;

      for (var i = 0; i < parent.children.length; i++) {
        parent.children[i].classList.remove(classes.gridSelected);
      }

      itemRef.current.classList.add(classes.gridSelected);
      props.onChange(props.item);
    },
    className: "".concat(classes.cardBody)
  }, props.headers.map(function (header, headerKey) {
    return header.rowName !== "addressName" && props.item[header.rowName] && /*#__PURE__*/_react["default"].createElement("p", {
      className: "".concat(classes.cardText),
      key: headerKey
    }, header.name, "\u200C ", props.item[header.rowName]);
  })), props.headers.map(function (header, headerKey) {
    return props.item.actions && props.item.actions[header.rowName !== 'checkbox' && header.rowName] && /*#__PURE__*/_react["default"].createElement("p", {
      className: "".concat(classes.left),
      key: headerKey
    }, header.name, "\u200C ", props.item.actions[header.rowName]);
  }))));
};

var _default = TableGrid;
exports["default"] = _default;